import "./mapComponent.less";

export const MyPositionMarker = ({
   lat,
   lng,
   text,
}: {
   lat: string;
   lng: string;
   text: string;
}) => (
   <div className="current-position-marker">
      <div>
         <div className="current-tail" />
      </div>
   </div>
);

export const PositionMarker = ({ lat, lng, text }: { lat: string; lng: string; text: string }) => {
   return (
      <button className="map-pin">
         <div className="map-pin__marker" />
      </button>
   );
};
